// console.log('navigation');
/**
 * File: navigation.js
 *
 * Handles navigation menu toggling, scroll behavior, and section highlighting.
 */
var Accordion = require('vanilla-js-accordion');
document.addEventListener('DOMContentLoaded', () => {
  const body = document.querySelector('body');
  const menuToggle = document.querySelector('#menu-toggle');

  // Menu toggling functions
  function toggleMenu() {
    body.classList.contains('menu-open') ? closeMenu() : openMenu();
  }

  function openMenu() {
    menuToggle.setAttribute('aria-expanded', 'true');
    body.classList.add('menu-start');
    setTimeout(() => body.classList.add('menu-open'), 1);
    setTimeout(() => body.classList.add('menu-animate'), 50);
  }

  function closeMenu() {
    body.classList.remove('menu-start', 'menu-animate');
    menuToggle.setAttribute('aria-expanded', 'false');
    setTimeout(() => body.classList.remove('menu-open'), 200);
  }

  // Event listeners

  menuToggle?.addEventListener('click', toggleMenu);
});
